






















































import Vue from 'vue';
import { Route } from 'vue-router';
import { mapActions, mapGetters, mapState } from 'vuex';
import LoaderInline from '@/components/LoaderInline.vue';

type CustomRoute = Partial<Route>;

export default Vue.extend({
  data: () => ({
    displayPlaceholder: true,
  }),
  computed: {
    ...mapGetters('search', [
      'isSearchLoading',
    ]),
    ...mapState('search', [
      'page',
      'result',
    ]),
    quickLink(): CustomRoute {
      const [{ type, id }] = (this as any).result;
      return {
        name: type,
        params: {
          [`${type}Id`]: id,
        },
      };
    },
  },
  methods: {
    ...mapActions('chrome', [
      'showStack',
    ]),
    ...mapActions('search', [
      'request',
    ]),
    clearSearch() {
      const searchBox = this.$refs.searchBox as HTMLElement;
      if (searchBox) {
        searchBox.textContent = '';
        searchBox.focus();
      }
    },
    updateDisplayPlaceholder(): void {
      this.displayPlaceholder = !this.getSearchText();
    },
    getSearchText() {
      const searchBox = this.$refs.searchBox as HTMLElement;
      return searchBox
        && searchBox.textContent
        && searchBox.textContent.trim();
    },
    performSearch(event: KeyboardEvent) {
      // update search value to trigger search
      const { searchBox } = this.$parent.$parent.$refs as { searchBox?: any };
      if (searchBox) {
        searchBox.searchValue = this.getSearchText();
      }
    },
    triggerAction(event: Event) {
      // creating a new line within search box
      event.preventDefault();

      const count = (this as any).result.length;
      if (count === 1) {
      // if there is one result visit the link
        this.$router.push(this.quickLink);
      } else if (count) {
        // show search window
        (this as any).showStack(1);
      } else {
        // TODO: shake if no results
        return;
      }
    },
  },
  components: {
    LoaderInline,
  },
});
